import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { syncHolidays } from "../../../core/data/redux/milestonesSlice";
import { all_routes } from "../../router/all_routes";
import { toast } from "react-toastify";

const DataSync = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  
  const [syncState, setSyncState] = useState({
    status: "IDLE", // IDLE, SYNCING, SUCCESS, FAILED
    lastSync: null as string | null
  });

  const handleSyncHolidays = async () => {
    setSyncState(prev => ({ ...prev, status: "SYNCING" }));
    try {
      const res = await dispatch(syncHolidays({ year: new Date().getFullYear() }));
      if (syncHolidays.fulfilled.match(res)) {
        setSyncState({
          status: "SUCCESS",
          lastSync: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        });
        toast.success("Holiday list synchronized successfully from SAP.");
      } else {
        throw new Error(res.payload || "API Error");
      }
    } catch (err: any) {
      setSyncState(prev => ({ ...prev, status: "FAILED" }));
      toast.error(`Sync Failed: ${err.message}`);
    }
  };

  return (
    <div className="page-wrapper bg-white">
      <style>{`
        .sync-list-item { border: 1px solid #f1f3f5; border-radius: 12px; transition: background 0.2s; }
        .sync-list-item:hover { background: #fafafa; }
        .icon-box-lite { width: 45px; height: 45px; border-radius: 10px; background: #f8f9fa; display: flex; align-items: center; justify-content: center; color: #495057; }
        .status-pill { font-size: 11px; font-weight: 700; padding: 4px 12px; border-radius: 30px; letter-spacing: 0.3px; }
        .status-idle { background: #f1f3f5; color: #6c757d; }
        .status-syncing { background: #e7f5ff; color: #007bff; }
        .status-success { background: #ebfbee; color: #2f9e44; }
        .status-failed { background: #fff5f5; color: #e03131; }
        
        @keyframes rotating {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .spinning { animation: rotating 2s linear infinite; }
      `}</style>

      <div className="content">
        {/* Simple Header */}
        <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
          <Link to={routes.adminDashboard} className="text-dark me-2">
            <i className="ti ti-arrow-left fs-20"></i>
          </Link>
          <h4 className="fw-bold mb-0">Data Synchronization</h4>
        </div>

        {/* Sync Instruction */}
        <div className="mb-4">
           <p className="text-muted small">Select the specific data set to synchronize with the HRMS Master Servers.</p>
        </div>

        {/* Sync List */}
        <div className="d-flex flex-column gap-3">
           <div className="sync-list-item p-3 d-flex align-items-center">
              <div className="icon-box-lite me-3">
                 <i className={`ti ti-calendar-event fs-22 ${syncState.status === 'SYNCING' ? 'spinning text-primary' : ''}`}></i>
              </div>
              
              <div className="flex-grow-1">
                 <div className="d-flex align-items-center gap-2 mb-1">
                    <h6 className="fw-bold mb-0 text-dark">Sync Holiday List</h6>
                    <span className={`status-pill status-${syncState.status.toLowerCase()}`}>
                       {syncState.status === 'SYNCING' ? 'SYNCING...' : syncState.status}
                    </span>
                 </div>
                 <small className="text-muted">Retrieve official DMRC holiday observations for {new Date().getFullYear()}.</small>
              </div>

              <div className="text-end me-4 d-none d-md-block">
                 <div className="text-muted" style={{ fontSize: '10px', fontWeight: 700 }}>LAST SYNC</div>
                 <div className="fw-bold small">{syncState.lastSync || '--:--'}</div>
              </div>

              <button 
                className={`btn ${syncState.status === 'SYNCING' ? 'btn-light' : 'btn-outline-danger'} rounded-pill px-4 fw-bold btn-sm`}
                onClick={handleSyncHolidays}
                disabled={syncState.status === 'SYNCING'}
              >
                 {syncState.status === 'SYNCING' ? 'Syncing...' : 'Sync Now'}
              </button>
           </div>
        </div>

        {/* Simple Footer Note */}
        <div className="mt-5 p-3 rounded-3 bg-light border border-dashed text-center">
           <p className="small text-muted mb-0">
             <i className="ti ti-shield-check me-1 text-success"></i> 
             Note: Updates reflect immediately across the employee portal once synchronization is complete.
           </p>
        </div>
      </div>
    </div>
  );
};

export default DataSync;
